module.exports = __webpack_public_path__ + "img/special_handle.6bf982d8.svg";